(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gingerkite-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-gk-preview]');
  if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
    const dialog = link.closest('.gk-content').querySelector('.gk-preview');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const image = link.querySelector('img').cloneNode();
    image.classList.remove('gk-content__image');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.loading = 'eager';
    image.src = link.href;
    dialog.querySelector('.gk-preview__canvas').replaceChildren(image);
    dialog.querySelector('.gk-preview__caption').textContent = link.getAttribute('aria-label');
    dialog.removeAttribute('data-zoomed');
    dialog.querySelector('[data-gk-zoom]').setAttribute('aria-pressed', 'false');
    dialog.addEventListener('close', () => link.focus(), { once:true });
    dialog.showModal();
  }
  const close = event.target.closest('[data-gk-close]');
  if (close) close.closest('dialog').close();
  const zoom = event.target.closest('[data-gk-zoom]');
  if (zoom) {
    const dialog = zoom.closest('dialog');
    zoom.setAttribute('aria-pressed', String(dialog.toggleAttribute('data-zoomed')));
  }
  if (event.target.matches('.gk-preview')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gingerkite-packages"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-offer-tracker')) {
    customElements.define('gk-offer-tracker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.offers = new Map(Array.from(this.querySelectorAll('[data-offer-id]'), element => [
          element, { id:crypto.randomUUID(), visible:false, seen:false, timer:null, retries:0 }
        ]));
        this.internal = new URLSearchParams(location.search).get('utm_source') === 'internal';
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-offer-details]');
          if (link) {
            const element = link.closest('[data-offer-id]');
            this.rememberDetails(element);
            this.send('offer_cta_tapped', element, { action:'view_details' });
          }
        }, options);
        this.addEventListener('gk:offer-action', event => {
          this.send('offer_cta_tapped', event.target, { action:event.detail.action });
        }, options);
        this.addEventListener('gk:offer-selected', event => {
          event.detail.waits.push(new Promise(resolve => {
            const timer = setTimeout(resolve, 500);
            const done = () => { clearTimeout(timer); resolve(); };
            if (!this.send('offer_decision_recorded', event.target, {
              decision:'selected', action:'choose_package', order_link_status:event.detail.orderLinkStatus,
              event_callback:done, event_timeout:500
            })) done();
          }));
        }, options);
        const refresh = () => this.offers.forEach((state, element) => this.refresh(element, state));
        if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name:'consent-tracking-api', version:'0.2' }], error => {
            if (!error && this.controller) refresh();
          });
        }
        document.addEventListener('visitorConsentCollected', refresh, options);
        document.addEventListener('visibilitychange', refresh, options);
        this.querySelectorAll('details').forEach(details => details.addEventListener('toggle', refresh, options));
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            const state = this.offers.get(entry.target);
            state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            this.refresh(entry.target, state);
          }
        }, { threshold:[0, 0.5, 1] });
        this.offers.forEach((state, element) => this.observer.observe(element));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.offers?.forEach(state => clearTimeout(state.timer));
      }
      allowed() {
        return !window.Shopify?.designMode &&
          window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      }
      orderProperties(element) {
        // Attribute only the newly added offer item. Existing cart contents retain
        // their original attribution; a later click must not claim their sale.
        try {
          const state = this.offers.get(element);
          if (!state || !this.allowed()) return {};
          return {
            _gk_offer_id:element.dataset.offerId,
            _gk_offer_role:element.dataset.offerRole,
            _gk_offer_version:this.dataset.version,
            _gk_offer_placement:this.dataset.placement,
            _gk_presentation_id:state.id,
            _gk_offer_action:'choose_package',
            _gk_selected_at:new Date().toISOString(),
            _gk_internal_test:this.internal ? '1' : '0'
          };
        } catch {
          return {};
        }
      }
      rememberDetails(element) {
        try {
          if (!this.allowed()) {
            sessionStorage.removeItem('gk_offer_referral');
            return;
          }
          const properties = this.orderProperties(element);
          if (!properties._gk_presentation_id) return;
          delete properties._gk_selected_at;
          properties._gk_offer_action = 'view_details';
          properties._gk_clicked_at = new Date().toISOString();
          sessionStorage.setItem('gk_offer_referral', JSON.stringify({
            properties, expires:Date.now() + 30 * 60 * 1000
          }));
        } catch {}
      }
      visible(element, state) {
        if (!state.visible || document.visibilityState !== 'visible') return false;
        const details = element.closest('details');
        if (details && !details.open) return false;
        const rect = element.getBoundingClientRect();
        const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
        const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
        return rect.width > 0 && rect.height > 0 && width * height >= rect.width * rect.height * 0.5;
      }
      refresh(element, state) {
        if (state.seen) return;
        if (!this.visible(element, state) || !this.allowed()) {
          clearTimeout(state.timer);
          state.timer = null;
          return;
        }
        if (state.timer) return;
        state.timer = setTimeout(() => {
          state.timer = null;
          if (!this.visible(element, state) || !this.allowed()) return;
          state.seen = this.send('offer_presented', element, { visibility_rule:'50pct_1sec' });
          if (!state.seen && ++state.retries < 10) this.refresh(element, state);
        }, 1000);
      }
      send(name, element, extra = {}) {
        try {
          const state = this.offers.get(element);
          if (!state || !this.allowed()) return false;
          if (typeof window.gtag !== 'function' && !window.dataLayer?.push) return false;
          const params = {
            send_to:this.dataset.measurementId,
            transport_type:'beacon',
            offer_id:element.dataset.offerId,
            offer_role:element.dataset.offerRole,
            offer_version:this.dataset.version,
            placement:this.dataset.placement,
            presentation_id:state.id,
            base_product_id:this.dataset.baseProduct,
            currency:this.dataset.currency,
            offer_amount_minor:Number(element.dataset.offerAmount),
            amount_basis:element.dataset.offerRole === 'add_on' ? 'additional_charge' : 'standalone_price',
            is_internal_test:this.internal ? 1 : 0,
            ...extra
          };
          if (typeof window.gtag === 'function') window.gtag('event', name, params);
          else (function () { window.dataLayer.push(arguments); })('event', name, params);
          return true;
        } catch {
          return false;
        }
      }
    });
  }
  if (!customElements.get('gk-package-choice')) {
    customElements.define('gk-package-choice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('[data-choose]');
        this.status = this.querySelector('[data-status]');
        this.review = this.querySelector('[data-review]');
        this.button.hidden = false;
        this.button.addEventListener('click', () => this.choose());
      }
      async choose() {
        if (this.busy) return;
        this.busy = true;
        this.button.disabled = true;
        this.dispatchEvent(new CustomEvent('gk:offer-action', { bubbles:true, detail:{ action:'choose_package' } }));
        this.status.textContent = '';
        this.review.hidden = true;
        try {
          const response = await fetch(this.dataset.cartUrl + '.js', { credentials:'same-origin', cache:'no-store' });
          if (!response.ok) throw new Error('cart');
          const cart = await response.json();
          const present = new Set(cart.items.filter(item => item.quantity > 0).map(item => String(item.variant_id)));
          if (this.dataset.starter && present.has(this.dataset.starter)) {
            this.status.textContent = this.dataset.overlap;
            this.review.hidden = false;
            return;
          }
          const missing = [this.dataset.base, this.dataset.addon].filter(id => !present.has(id));
          const properties = this.closest('gk-offer-tracker')?.orderProperties(this) || {};
          const orderLinkStatus = present.has(this.dataset.addon) ? 'existing_line' :
            (properties._gk_presentation_id ? 'attached' : 'unavailable');
          if (missing.length) {
            const added = await fetch(this.dataset.cartUrl + '/add.js', {
              method:'POST', credentials:'same-origin',
              headers:{ 'Content-Type':'application/json' },
              body:JSON.stringify({ items:missing.map(id => ({
                id, quantity:1, ...(id === this.dataset.addon ? { properties } : {})
              })) })
            });
            if (!added.ok) throw new Error('add');
          }
          const waits = [];
          this.dispatchEvent(new CustomEvent('gk:offer-selected', { bubbles:true, detail:{ waits, orderLinkStatus } }));
          await Promise.all(waits);
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.status.textContent = this.dataset.error;
          this.review.hidden = false;
        } finally {
          this.busy = false;
          this.button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
